import { AuthRoutes } from '../features/auth';
import { DataProtectionRoutes } from '../features/dataProtection';
import { EmailSettings } from '../features/emailSettings';
import ExtensionLogin from '../features/extension/components/ExtensionLogin';
import { VendorPublicRoutes } from '../features/vendors/routes';
// import { lazyImport } from '../utils/lazyImport';
export const publicRoutes = [
  {
    path: '/*',
    element: <AuthRoutes />,
  },
  {
    path: '/email-settings/*',
    element: <EmailSettings />,
  },
  {
    path: '/data-protection/*',
    element: <DataProtectionRoutes />,
  },
  {
    path: '/vendors',
    element: <VendorPublicRoutes />,
  },
  {
    path: '/extension/*',
    element: <ExtensionLogin />,
  },
];
